const ImportDataIconActive = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M0 4.66671C0 2.82871 1.49533 1.33337 3.33333 1.33337H12.6667C14.5047 1.33337 16 2.82871 16 4.66671H0ZM7.33333 6.00004H0V9.33337H7.33333V6.00004ZM16 6.00004H8.66667V9.33337H16V6.00004ZM7.33333 10.6667H0V11.3334C0 13.1714 1.49533 14.6667 3.33333 14.6667H7.33333V10.6667ZM8.66667 10.6667V14.6667H12.6667C14.5047 14.6667 16 13.1714 16 11.3334V10.6667H8.66667Z'
        fill='white'
      />
    </svg>
  );
};

export default ImportDataIconActive;
